import $ from 'jquery';
import {wishlistShareForm} from './wishlist-share-form';
import {wishlistProducts} from './wishlist-products';

const selectors = {
  shareForm: '[data-wishlist-share]',
  products: '#wishlist-items-container',
};

const $products = $(selectors.products);
const $form = $(selectors.shareForm);

wishlistShareForm($form);
wishlistProducts($products);

/**
 * @param {Object[]} products
 */
function toggleShare(products = []) {
  const hasProducts = Boolean(products.length);

  $(selectors.shareForm).toggleClass('is-visible', hasProducts);
}

/**
 * @param {CustomEvent} event
 */
function handleLoadedProducts(event) {
  const {detail = {}} = event;

  toggleShare(detail.products);
}

function handleWishlistProducts() {
  window._swat.fetch(
    toggleShare,
    window._swat.EventTypes.addToWishList,
  );
}

$(document).on('wishlist:updated', handleWishlistProducts);
$(document).on('wishlist:loaded', handleLoadedProducts);
